"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockLibraryTab = void 0;
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_1 = require("mobx");
var DragStore_1 = require("Project/Stores/DragStore/DragStore");
var react_1 = __importStar(require("react"));
var TelemetryEnums_1 = require("Telemetry/TelemetryEnums");
var BlockLibraryExplainer_1 = require("./BlockLibraryExplainer/BlockLibraryExplainer");
var classnames_1 = __importDefault(require("classnames"));
var GhostBlockCard_1 = require("./BlockCard/GhostBlockCard");
var Types_1 = require("@CommonFrontendBackend/SavedBlocks/Types");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var DashboardUtils_1 = require("Dashboard/DashboardUtils");
var SavedBlockFilterSelector_1 = __importDefault(require("SavedBlock/SavedBlockFilterSelector/SavedBlockFilterSelector"));
var SortBySelector_1 = __importDefault(require("Dashboard/SortBySelector/SortBySelector"));
var SavedBlockViewStore_1 = require("SavedBlock/SavedBlockViewStore");
var generateThumbnailId_1 = require("@CommonFrontendBackend/SavedBlocks/generateThumbnailId");
var BlockCard_1 = __importDefault(require("./BlockCard/BlockCard"));
var mobx_react_1 = require("mobx-react");
var block_library_sidebar_empty_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-library-sidebar-empty.svg"));
var BetterInfiniteScroll_1 = require("../Images/BetterInfiniteScroll/BetterInfiniteScroll");
var CONTENT_SIDEBAR_BASE_CLASS_NAME = "content-sidebar";
var BlockLibraryTab = (function (_super) {
    __extends(BlockLibraryTab, _super);
    function BlockLibraryTab() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.savedBlockExplainerBeingDismissed = false;
        _this.onDismissBlockLibraryExplainer = function () {
            _this.props.useHistoryDataStore.dismissBlockLibraryExplainer();
        };
        _this.onBlockLibraryExplainerExited = function () {
            _this.savedBlockExplainerBeingDismissed = false;
        };
        _this.onBlockLibraryExplainerExit = function () {
            _this.savedBlockExplainerBeingDismissed = true;
        };
        _this.getCurrentName = function () {
            var folderId = _this.props.savedBlocksFolderViewStore.folderSelectionStore.selectedFolder;
            if ((0, DashboardUtils_1.isASystemFolder)(folderId)) {
                return (0, DashboardUtils_1.getBlockFolderTitle)(folderId);
            }
            return _this.props.savedBlocksFolderViewStore.getFolderName(_this.props.savedBlocksFolderViewStore.folderSelectionStore.selectedFolder);
        };
        _this.renderActionsRow = function () {
            var _a = _this.props, savedBlockViewStore = _a.savedBlockViewStore, telemetry = _a.telemetry, usingFeature = _a.usingFeature;
            var label = "Search ".concat(_this.getCurrentName());
            return (react_1.default.createElement("div", { className: "".concat(CONTENT_SIDEBAR_BASE_CLASS_NAME, "__actions") },
                react_1.default.createElement("div", { className: "sort-filter-wrapper" },
                    react_1.default.createElement(kaleidoscope_2.FolderComponent, { onClick: _this.props.contentSidebarLibraryViewStore.toggleFolderTree, selected: true, icon: react_1.default.createElement(icons_1.Folder, null), name: _this.getCurrentName() }),
                    react_1.default.createElement(SavedBlockFilterSelector_1.default, { savedBlockViewStore: savedBlockViewStore, telemetry: telemetry, compactButton: true, telemetryContext: TelemetryEnums_1.SavedBlockOrigin.Sidebar, filterContext: "contentSidebar", usingFeature: usingFeature }),
                    react_1.default.createElement(SortBySelector_1.default, { menuAssets: SavedBlockViewStore_1.sortMenuAssets, selectedMenuItem: savedBlockViewStore.getSelectedSortMenuItem(), onSelectMenuItemHandle: savedBlockViewStore.onSelectSortMenuItemHandle, compactButton: true, sortDirection: savedBlockViewStore.sortDirection })),
                react_1.default.createElement("div", { className: "search-wrapper" },
                    react_1.default.createElement(kaleidoscope_1.SearchInput, { label: label, placeholder: label, onChange: function (value) {
                            savedBlockViewStore.setSearchTerm(value);
                            telemetry.debouncedTrack("Sidebar Assets Searched", {
                                source_tab: "your_library",
                                source_secondary_tab: "blocks",
                            }, {
                                blockIntercom: true,
                            }, 500);
                        }, value: savedBlockViewStore.searchTerm, onClear: function () { return savedBlockViewStore.setSearchTerm(""); } }))));
        };
        _this.renderEmptyState = function () {
            return (react_1.default.createElement("div", { className: "".concat(CONTENT_SIDEBAR_BASE_CLASS_NAME, "__empty-search-result") },
                react_1.default.createElement(kaleidoscope_1.EmptyState, { title: "There's nothing here!", subtitle: "We couldn't find any saved blocks that match.", className: "".concat(CONTENT_SIDEBAR_BASE_CLASS_NAME, "__empty-state") })));
        };
        _this.renderMainContent = function () {
            var _a;
            var _b = _this.props, savedBlockViewStore = _b.savedBlockViewStore, useHistoryDataStore = _b.useHistoryDataStore, contentSidebarViewStore = _b.contentSidebarViewStore;
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(CONTENT_SIDEBAR_BASE_CLASS_NAME, "__list")), id: "".concat(CONTENT_SIDEBAR_BASE_CLASS_NAME, "__list") },
                react_1.default.createElement(BlockLibraryExplainer_1.BlockLibraryExplainer, { show: useHistoryDataStore.shouldShowBlockLibraryExplainer, onDismiss: _this.onDismissBlockLibraryExplainer, onExit: _this.onBlockLibraryExplainerExit, onExited: _this.onBlockLibraryExplainerExited }),
                react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(CONTENT_SIDEBAR_BASE_CLASS_NAME, "__list-cards"), (_a = {},
                        _a["".concat(CONTENT_SIDEBAR_BASE_CLASS_NAME, "__list-cards--offset")] = _this.savedBlockExplainerBeingDismissed,
                        _a)) },
                    savedBlockViewStore.isLoading && _this.renderLoadingState(),
                    contentSidebarViewStore.isOpen && !savedBlockViewStore.isLoading && (react_1.default.createElement(BetterInfiniteScroll_1.BetterInfiniteScroll, { next: savedBlockViewStore.incrementPage, hasMore: savedBlockViewStore.hasMoreToPaginate, loader: react_1.default.createElement("div", { className: "".concat(CONTENT_SIDEBAR_BASE_CLASS_NAME, "__list-spinner-wrapper") },
                            react_1.default.createElement(kaleidoscope_1.Spinner, null)), dataLength: savedBlockViewStore.savedBlocksPaginated.length, scrollableTarget: "".concat(CONTENT_SIDEBAR_BASE_CLASS_NAME, "__list"), style: { overflow: "initial" } }, savedBlockViewStore.savedBlocksPaginated.map(function (savedBlock) {
                        return _this.renderCard(savedBlock);
                    }))))));
        };
        _this.renderCard = function (savedBlock) {
            var _a = _this.props, savedBlockViewStore = _a.savedBlockViewStore, dragStore = _a.dragStore, dropzonesStore = _a.dropzonesStore, savedBlockOpener = _a.savedBlockOpener, userIsAdmin = _a.userIsAdmin, canEditQuoteV1 = _a.canEditQuoteV1;
            var thumbnailUrl = _this.getThumbnailUrl(savedBlock.id);
            return (react_1.default.createElement(BlockCard_1.default, { key: savedBlock.id, onDragStart: function (event) { return _this.handleDragStart(event, savedBlock); }, onDragEnd: function () {
                    (0, mobx_1.runInAction)(function () {
                        dragStore.stopDrag();
                        dropzonesStore.onDragEnd();
                    });
                }, blockType: savedBlock.type, name: savedBlock.savedBlockName, editingIsLockedToAdmins: savedBlock.$editingLockedToAdmins, userIsAdmin: userIsAdmin, blockId: savedBlock.id, thumbnailUrl: thumbnailUrl, createdAt: (0, CommonUtils_1.convertTimeStringToDateString)(savedBlock.createdAt), onDeleteClick: function () {
                    savedBlockViewStore.deleteSavedBlock(savedBlock.id);
                }, onEditClick: function () {
                    savedBlockOpener.edit(savedBlock, TelemetryEnums_1.SavedBlockOrigin.Sidebar);
                }, onPreviewClick: function () {
                    savedBlockOpener.preview(savedBlock, TelemetryEnums_1.SavedBlockOrigin.Sidebar);
                }, onClick: function () { }, onToggleEditingIsLockedToAdmins: function () {
                    savedBlockViewStore.setLockEditingSettingForSavedBlock(savedBlock.id, !savedBlock.$editingLockedToAdmins);
                }, canEditQuoteV1: canEditQuoteV1 }));
        };
        return _this;
    }
    BlockLibraryTab.prototype.openHelpArticle = function () {
        if (window.Beacon) {
            window.Beacon("open");
            window.Beacon("article", "5ab2ad682c7d3a56d8872f96");
        }
        else {
            window.open("https://help.qwilr.com/article/92-saving-reusing-blocks");
        }
    };
    BlockLibraryTab.prototype.render = function () {
        var savedBlockViewStore = this.props.savedBlockViewStore;
        var showEmptyState = savedBlockViewStore.savedBlocksPaginated.length === 0;
        var hasNoSavedBlocks = savedBlockViewStore.savedBlockCount === 0;
        if (hasNoSavedBlocks) {
            return this.renderNoBlocksState();
        }
        else {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                this.renderActionsRow(),
                showEmptyState && this.renderEmptyState(),
                !showEmptyState && this.renderMainContent()));
        }
    };
    BlockLibraryTab.prototype.renderNoBlocksState = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            this.renderActionsRow(),
            react_1.default.createElement("div", { className: "".concat(CONTENT_SIDEBAR_BASE_CLASS_NAME, "__no-blocks") },
                react_1.default.createElement(kaleidoscope_1.EmptyState, { image: react_1.default.createElement(kaleidoscope_1.SVG, { src: block_library_sidebar_empty_svg_1.default }), title: "Build pages faster", subtitle: "Save your favourite blocks of content to your Block Library, then drag and drop them into any page.", className: "".concat(CONTENT_SIDEBAR_BASE_CLASS_NAME, "__no-blocks-empty-state") }),
                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, onClick: this.openHelpArticle }, "Find out how"))));
    };
    BlockLibraryTab.prototype.renderLoadingState = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null, __spreadArray([], __read(Array(3).keys()), false).map(function (value, i) { return (react_1.default.createElement(GhostBlockCard_1.GhostBlockCard, { key: i })); })));
    };
    BlockLibraryTab.prototype.getThumbnailUrl = function (savedBlockId) {
        var _a = this.props, accountId = _a.accountId, thumbnailBaseUrl = _a.thumbnailBaseUrl;
        var savedBlockThumbnailId = (0, generateThumbnailId_1.generateThumbnailId)(accountId, savedBlockId);
        return "".concat(thumbnailBaseUrl, "/v1/artefact/").concat(savedBlockThumbnailId, "/thumbnail");
    };
    BlockLibraryTab.prototype.handleDragStart = function (event, savedBlock) {
        event.dataTransfer.setData("application/text", savedBlock.savedBlockName);
        event.dataTransfer.effectAllowed = "copy";
        var _a = this.props, dragStore = _a.dragStore, contentSidebarLibraryViewStore = _a.contentSidebarLibraryViewStore;
        (0, mobx_1.runInAction)(function () {
            dragStore.startDrag([
                {
                    id: savedBlock.id,
                    type: DragStore_1.DragType.SavedBlock,
                },
            ]);
        });
        contentSidebarLibraryViewStore.hideFolders();
    };
    var _a, _b;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], BlockLibraryTab.prototype, "savedBlockExplainerBeingDismissed", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockLibraryTab.prototype, "onDismissBlockLibraryExplainer", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockLibraryTab.prototype, "onBlockLibraryExplainerExited", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockLibraryTab.prototype, "onBlockLibraryExplainerExit", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof react_1.default !== "undefined" && react_1.default.DragEvent) === "function" ? _a : Object, typeof (_b = typeof Types_1.SavedBlock !== "undefined" && Types_1.SavedBlock) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], BlockLibraryTab.prototype, "handleDragStart", null);
    BlockLibraryTab = __decorate([
        mobx_react_1.observer
    ], BlockLibraryTab);
    return BlockLibraryTab;
}(react_1.Component));
exports.BlockLibraryTab = BlockLibraryTab;
